import { render, staticRenderFns } from "./changeNick.vue?vue&type=template&id=f26a891c&scoped=true&"
import script from "./changeNick.vue?vue&type=script&lang=js&"
export * from "./changeNick.vue?vue&type=script&lang=js&"
import style0 from "./changeNick.vue?vue&type=style&index=0&id=f26a891c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26a891c",
  null
  
)

export default component.exports